import { FunctionComponent, useState } from 'react';
import dynamic from 'next/dynamic';
import classnames from 'classnames';

import Button, { ButtonStyles } from 'components/layout/Button';
import Spinner from 'components/layout/Spinner/component';
import Description from 'components/modules/public/layout/sections/Description';

import StyledComponent from './styles';
import { Props } from './types';

const DynamicWorkerContactForm = dynamic(
    () => import('components/modules/public/layout/forms/WorkerContactForm'),
    { loading: () => <Spinner /> }
);

const PublicPageFaqSectionContact: FunctionComponent<Props> = ({
    buttonProps,
    descriptionProps,
    descriptionPropsAlt,
    form,
}) => {
    const [open, SetOpen] = useState(false);
    function handleOpenForm() {
        SetOpen(true);
    }

    return (
        <StyledComponent
            className={classnames('public-page-faq-section-contact',
                {
                    'form-open': open,
                }
            )}
        >
            {!open && (

                <Description {...descriptionProps}>
                    <Button
                        {...buttonProps}
                        style={ButtonStyles.Secondary}
                        onClick={() => handleOpenForm()}
                    />
                </Description>
            )}
            {open && (
                <Description {...descriptionPropsAlt}>
                    <DynamicWorkerContactForm {...form} />
                </Description>
            )}
        </StyledComponent>
    );
};

export default PublicPageFaqSectionContact;